import { getPortalCodeFromUrl } from "./getPortalCodeFromUrl";
import isMobile from "./isMobile";
import { findSiteData } from "./valueGet";

/** 删除字符串末尾的‘/’ 并返回以‘/’分割的数组 */
var splitPath = function splitPath(pathname) {
  var purePath = (pathname === null || pathname === void 0 ? void 0 : pathname.replace(/([\w\W]+)\/$/, '$1')) || '';
  return (purePath === null || purePath === void 0 ? void 0 : purePath.split('/')) || [];
};

/**
 * 匹配路由函数
 * @param currentRoute 当前路由
 * @param route 权限录入中的路由
 * @returns true｜false
 * @description 匹配规则:
 *  当基于路由字符串分割的数组 长度不同时 返回false
 *  当权限录入中的路由与当前路由匹配时，通配符位置不做判断，非通配符位置全量匹配，匹配失败则返回false
 * */
var matchPath = function matchPath() {
  var currentRoute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var routeArr = splitPath(route);
  var currentRouteArr = splitPath(currentRoute);
  if (routeArr.length !== currentRouteArr.length) {
    return false;
  } else {
    var final = routeArr.reduce(function (prev, item, index) {
      if (prev) {
        if (item.indexOf('*') === -1) {
          if (item === currentRouteArr[index]) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    }, true);
    return final;
  }
};
var currentAlias = getPortalCodeFromUrl({
  isGetDomain: true
});

/** pc转换为h5 */
var pcMapH5 = {
  '/': {
    queryTransform: function queryTransform() {
      return "/";
    }
  },
  '/home': {
    queryTransform: function queryTransform() {
      return "/home";
    }
  },
  '/user-center/user/login': {
    queryTransform: function queryTransform() {
      return "/user-center/user/login";
    }
  },
  '/practice/list': {
    queryTransform: function queryTransform() {
      return "/exam-center/practice-list";
    }
  },
  '/user-center/account': {
    queryTransform: function queryTransform() {
      return "/user-center/mine";
    }
  },
  '/micro': {
    queryTransform: function queryTransform() {
      var _window = window,
        search = _window.location.search;
      return "/micro".concat(search);
    }
  },
  '/mine/train-center/mine/student/subPages/student/class': {
    queryTransform: function queryTransform() {
      return "/career/study";
    }
  },
  '/train-center/lesson': {
    queryTransform: function queryTransform() {
      return "/career/lesson/list";
    }
  },
  '/train-center/lesson/*': {
    queryTransform: function queryTransform() {
      var _window2 = window,
        pathname = _window2.location.pathname;
      var pathArr = splitPath(pathname);
      var id = pathArr.pop();
      return "/career/lesson/detail?id=".concat(id);
    }
  },
  '/mine/train-center/mine/student/certificate': {
    queryTransform: function queryTransform() {
      return "/career/mine/certificate";
    }
  },
  '/picture/list': {
    queryTransform: function queryTransform() {
      var _window3 = window,
        search = _window3.location.search;
      return "/picture/list".concat(search);
    }
  },
  '/picture/detail': {
    queryTransform: function queryTransform() {
      var _window4 = window,
        search = _window4.location.search;
      return "/picture/detail".concat(search);
    }
  },
  '/mine/exam/mine/student/workbench': {
    queryTransform: function queryTransform() {
      return "/assessment/exam";
    }
  },
  '/exam/gateway/achievement-query': {
    queryTransform: function queryTransform() {
      return "/assessment/score/query";
    }
  },
  '/exam/gateway/certificate-query': {
    queryTransform: function queryTransform() {
      return "/assessment/certificate/query";
    }
  },
  '/exam/gateway/plan-publicity': {
    queryTransform: function queryTransform() {
      return "/assessment/planPublicity";
    }
  },
  '/exam/gateway/plan-publicity/1/*': {
    queryTransform: function queryTransform() {
      var _window5 = window,
        pathname = _window5.location.pathname;
      var pathArr = splitPath(pathname);
      var plan_id = pathArr.pop();
      return "/assessment/planPublicity/detail?plan_id=".concat(plan_id);
    }
  },
  '/exam/gateway/result-publicity': {
    queryTransform: function queryTransform() {
      return "/assessment/resultPublicity";
    }
  },
  '/exam/gateway/result-publicity/2/*': {
    queryTransform: function queryTransform() {
      var _window6 = window,
        pathname = _window6.location.pathname;
      var pathArr = splitPath(pathname);
      var plan_id = pathArr.pop();
      return "/assessment/resultPublicity/detail?plan_id=".concat(plan_id);
    }
  },
  // '/exam/mine/student/achievement': {
  //   queryTransform: () => {
  //     return `/home`;
  //   },
  // },
  // '/exam/mine/student/certificate': {
  //   queryTransform: () => {
  //     return `/home`;
  //   },
  // },
  // '/exam/mine/student/workbench': {
  //   queryTransform: () => {
  //     return `/home`;
  //   },
  // },
  '/enroll-center/enroll-list': {
    queryTransform: function queryTransform() {
      var _window7 = window,
        _window7$location$sea = _window7.location.search,
        search = _window7$location$sea === void 0 ? '' : _window7$location$sea;
      var h5Search = search.replace('type', 'entryCodeInteger');
      return "/enroll-center/list".concat(h5Search);
    }
  },
  '/enroll-center/enroll-detail': {
    queryTransform: function queryTransform() {
      var _window8 = window,
        _window8$location$sea = _window8.location.search,
        search = _window8$location$sea === void 0 ? '' : _window8$location$sea;
      return "/enroll-center/details".concat(search);
    }
  },
  '/enroll-center/enroll-information': {
    queryTransform: function queryTransform() {
      var _window9 = window,
        _window9$location$sea = _window9.location.search,
        search = _window9$location$sea === void 0 ? '' : _window9$location$sea;
      search = search.replace('?', '');
      search = '"' + search.replaceAll('=', '":"').replaceAll('&', '","') + '"';
      search = "{".concat(search, "}");
      var searchObj = JSON.parse(search);
      var _ref = searchObj || {},
        careerCode = _ref.careerCode,
        organizationCode = _ref.organizationCode,
        activityCode = _ref.activityCode,
        applyChannel = _ref.applyChannel,
        record = _ref.record;
      var tempObj = {
        code: activityCode,
        applyChannel: applyChannel,
        type: 0,
        jobCode: careerCode,
        // jobName,
        recordCode: record,
        organizationCode: organizationCode
        // recordAuthCode,
      };

      if (organizationCode) {
        //@ts-ignore
        tempObj.type = 'organization';
      }
      if (activityCode) {
        //@ts-ignore
        tempObj.type = 'plan';
      }
      if (careerCode && organizationCode) {
        //@ts-ignore
        tempObj.type = 'career';
      }
      switch (tempObj.type) {
        //@ts-ignore
        case 'organization':
          tempObj.organizationCode = organizationCode;
          delete tempObj.code;
          break;
        //@ts-ignore
        case 'plan':
          tempObj.code = activityCode;
          break;
        //@ts-ignore
        case 'career':
          return '';
      }
      Object.keys(tempObj).map(function (key) {
        //@ts-ignore
        if (!tempObj[key]) {
          //@ts-ignore
          delete tempObj[key];
        }
      });
      //@ts-ignore
      var queryArr = Object.keys(tempObj).map(function (key) {
        return "".concat(key, "=").concat(tempObj[key]);
      });
      return "/enroll-center/enroll-online?".concat(queryArr.join('&'));
    }
  },
  '/enroll-center/my-enrollment': {
    queryTransform: function queryTransform() {
      return "/enroll-center/my-enrollment";
    }
  },
  '/mine/enroll-center/my-enrollment': {
    queryTransform: function queryTransform() {
      return "/enroll-center/my-enrollment";
    }
  }
};

/** h5转换为pc */
var h5MapPc = {
  '/home': {
    queryTransform: function queryTransform() {
      return "/home";
    }
  },
  '/micro': {
    queryTransform: function queryTransform() {
      var _window10 = window,
        search = _window10.location.search;
      return "/micro".concat(search);
    }
  },
  '/career/study': {
    queryTransform: function queryTransform() {
      return "/train-center/mine/student/subPages/student/class";
    }
  },
  '/career/lesson/list': {
    queryTransform: function queryTransform() {
      return "/train-center/lesson";
    }
  },
  '/career/lesson/detail': {
    queryTransform: function queryTransform() {
      var _window11 = window,
        _window11$location$se = _window11.location.search,
        search = _window11$location$se === void 0 ? '' : _window11$location$se;
      search = search.replace('?', '');
      search = '"' + search.replaceAll('=', '":"').replaceAll('&', '","') + '"';
      search = "{".concat(search, "}");
      var searchObj = JSON.parse(search);
      return "/train-center/lesson/".concat(searchObj === null || searchObj === void 0 ? void 0 : searchObj.id);
    }
  },
  '/career/mine/certificate': {
    queryTransform: function queryTransform() {
      return "/mine/train-center/mine/student/certificate";
    }
  },
  '/picture/list': {
    queryTransform: function queryTransform() {
      var _window12 = window,
        search = _window12.location.search;
      return "/picture/list".concat(search);
    }
  },
  '/picture/detail': {
    queryTransform: function queryTransform() {
      var _window13 = window,
        search = _window13.location.search;
      return "/picture/detail".concat(search);
    }
  },
  '/assessment/exam': {
    queryTransform: function queryTransform() {
      return "/mine/exam/gateway/self-exam";
    }
  },
  '/assessment/score/query': {
    queryTransform: function queryTransform() {
      return "/exam/gateway/achievement-query";
    }
  },
  '/assessment/certificate/query': {
    queryTransform: function queryTransform() {
      return "/exam/gateway/certificate-query";
    }
  },
  '/assessment/planPublicity': {
    queryTransform: function queryTransform() {
      return "/exam/gateway/plan-publicity?page_type=1";
    }
  },
  '/assessment/planPublicity/detail': {
    queryTransform: function queryTransform() {
      var _window14 = window,
        _window14$location$se = _window14.location.search,
        search = _window14$location$se === void 0 ? '' : _window14$location$se;
      search = search.replace('?', '');
      search = '"' + search.replaceAll('=', '":"').replaceAll('&', '","') + '"';
      search = "{".concat(search, "}");
      var searchObj = JSON.parse(search);
      return "/exam/gateway/publicity/1/".concat(searchObj === null || searchObj === void 0 ? void 0 : searchObj.plan_id);
    }
  },
  '/assessment/resultPublicity': {
    queryTransform: function queryTransform() {
      return "/exam/gateway/result-publicity";
    }
  },
  '/assessment/resultPublicity/detail': {
    queryTransform: function queryTransform() {
      var _window15 = window,
        _window15$location$se = _window15.location.search,
        search = _window15$location$se === void 0 ? '' : _window15$location$se;
      search = search.replace('?', '');
      search = '"' + search.replaceAll('=', '":"').replaceAll('&', '","') + '"';
      search = "{".concat(search, "}");
      var searchObj = JSON.parse(search);
      return "/exam/gateway/publicity/2/".concat(searchObj === null || searchObj === void 0 ? void 0 : searchObj.plan_id);
    }
  },
  // '/assessment/score/query': {
  //   path: '/exam/mine/student/achievement',
  //
  // },
  // '/assessment/certificate/query': {
  //   path: '/exam/mine/student/certificate',
  //
  // },
  '/enroll-center/list': {
    queryTransform: function queryTransform() {
      var _window16 = window,
        _window16$location$se = _window16.location.search,
        search = _window16$location$se === void 0 ? '' : _window16$location$se;
      search = search.replace('?', '');
      search = '"' + search.replaceAll('=', '":"').replaceAll('&', '","') + '"';
      search = "{".concat(search, "}");
      var searchObj = JSON.parse(search);
      return "/enroll-center/enroll-list?type=".concat(searchObj === null || searchObj === void 0 ? void 0 : searchObj.entryCodeInteger);
    }
  },
  '/enroll-center/details': {
    queryTransform: function queryTransform() {
      var _window17 = window,
        search = _window17.location.search;
      return "/enroll-center/enroll-detail".concat(search);
    }
  },
  '/enroll-center/enroll-online': {
    queryTransform: function queryTransform() {
      var _window18 = window,
        _window18$location$se = _window18.location.search,
        search = _window18$location$se === void 0 ? '' : _window18$location$se;
      search = search.replace('?', '');
      search = '"' + search.replaceAll('=', '":"').replaceAll('&', '","') + '"';
      search = "{".concat(search, "}");
      var searchObj = JSON.parse(search);
      var code = searchObj.code,
        applyChannel = searchObj.applyChannel,
        type = searchObj.type,
        jobCode = searchObj.jobCode,
        jobName = searchObj.jobName,
        recordCode = searchObj.recordCode,
        organizationCode = searchObj.organizationCode,
        recordAuthCode = searchObj.recordAuthCode;
      var tempObj = {
        careerCode: jobCode,
        organizationCode: organizationCode,
        activityCode: code,
        applyChannel: applyChannel,
        record: recordCode
      };
      Object.keys(tempObj).map(function (key) {
        //@ts-ignore
        if (!tempObj[key]) {
          //@ts-ignore
          delete tempObj[key];
        }
      });
      //@ts-ignore
      var queryArr = Object.keys(tempObj).map(function (key) {
        return "".concat(key, "=").concat(tempObj[key]);
      });
      return "/enroll-center/enroll-information?".concat(queryArr.join('&'));
    }
  },
  '/enroll-center/my-enrollment': {
    queryTransform: function queryTransform() {
      return "/enroll-center/my-enrollment";
    }
  }
};
var bsaasTerminalMap = function bsaasTerminalMap() {
  var siteData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _window19 = window,
    origin = _window19.origin,
    pathname = _window19.location.pathname;

  // !orderOrigin ? (orderOrigin = origin) : '';

  var saasPC = RUN_ENV === 'local' ? 'http://localhost:8031' : findSiteData(siteData, 'burl').value || '';
  var saasH5 = RUN_ENV === 'local' ? 'http://localhost:9013' : findSiteData(siteData, 'portalH5Url').value || '';
  var isSaasPC = origin === saasPC;
  var isSaasH5 = origin === saasH5;
  var isH5 = isMobile();
  var mapItem = {};
  if (isSaasPC) {
    // 当前项目为pc门户
    if (isH5) {
      // 当前设备为h5
      var mapKey = Object.keys(pcMapH5).find(function (key) {
        return matchPath(pathname, "/".concat(currentAlias).concat(key));
      }) || '';
      //@ts-ignore
      mapItem = pcMapH5[mapKey];
      if (mapItem && mapItem.queryTransform()) {
        // 存在匹配的pc路由 重组url 并跳转
        return {
          rightTerminal: false,
          url: "".concat(saasH5, "/").concat(currentAlias).concat(mapItem.queryTransform())
        };
      } else {
        // 不存在匹配的pc路由
        return {
          rightTerminal: false,
          url: ''
        };
      }
    } else {
      // 当前设备不是h5 不需要转换
      return {
        rightTerminal: true,
        url: ''
      };
    }
  }
  if (isSaasH5) {
    // 当前项目为h5门户
    if (isH5) {
      // 当前设备为h5 不需要转换
      return {
        rightTerminal: true,
        url: ''
      };
    } else {
      // 当前设备为pc 需要转换为pc的链接
      var _mapKey = Object.keys(h5MapPc).find(function (key) {
        return matchPath(pathname, "/".concat(currentAlias).concat(key));
      }) || '';
      //@ts-ignore
      mapItem = h5MapPc[_mapKey];
      if (mapItem) {
        // 存在匹配的pc路由 重组url 并跳转
        return {
          rightTerminal: false,
          url: "".concat(saasPC, "/").concat(currentAlias).concat(mapItem.queryTransform())
        };
      } else {
        // 不存在匹配的pc路由
        return {
          rightTerminal: false,
          url: ''
        };
      }
    }
  }
};
export default bsaasTerminalMap;